module.exports = "/images/mastercard.png";